import { Drawer, Table } from "@mantine/core";
import { AdminTable } from "../../../components/AdminTable.tsx";

type SimResult = {
  prizeId: string;
  code: string;
  expected: number;
  actual: number;
  deviation: number;
};

type Props = {
  opened: boolean;
  onClose: () => void;
  simResult: SimResult[] | null;
  prizeNames: Map<string, string>;
};

export function SimulateDrawer({ opened, onClose, simResult, prizeNames }: Props) {
  return (
    <Drawer
      opened={opened}
      onClose={onClose}
      title="蒙特卡洛模拟 (10000 次)"
      position="right"
      size="lg"
      keepMounted={false}
    >
      {simResult !== null ? (
        <AdminTable minWidth={400}>
          <Table.Thead>
            <Table.Tr>
              <Table.Th>名称</Table.Th>
              <Table.Th>code</Table.Th>
              <Table.Th>预期命中</Table.Th>
              <Table.Th>实际命中</Table.Th>
              <Table.Th>偏差 %</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {simResult.map((r) => (
              <Table.Tr key={r.prizeId}>
                <Table.Td>{prizeNames.get(r.prizeId) ?? "-"}</Table.Td>
                <Table.Td>{r.code}</Table.Td>
                <Table.Td>{r.expected}</Table.Td>
                <Table.Td>{r.actual}</Table.Td>
                <Table.Td>{r.deviation.toFixed(2)}</Table.Td>
              </Table.Tr>
            ))}
          </Table.Tbody>
        </AdminTable>
      ) : null}
    </Drawer>
  );
}
